import { render, staticRenderFns } from "./StoriesTrending.vue?vue&type=template&id=7114b064&"
import script from "./StoriesTrending.vue?vue&type=script&lang=js&"
export * from "./StoriesTrending.vue?vue&type=script&lang=js&"
import style0 from "./StoriesTrending.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports